<div class="title">
    <span>{{ 'realtime:alarmFor' | i18next }} {{ 'translation:Calls' | i18next }}</span>
        <i id="close-btn-alarm-dialog" class="close-icon" mat-button cdkFocusInitial [mat-dialog-close]="false" (click)="closeDialog()"></i>
</div>
<div class="dialog-content">
  <table class="full-width-table" *ngIf="items?.length; else noData">
    <thead>
      <tr class="mat-mdc-header-row">
        <th>{{ 'realtime:alarmName' | i18next }}</th>
        <th>{{ 'realtime:alarmQueue' | i18next }}</th>
        <th>{{ 'realtime:alarmThreshold' | i18next }}</th>
        <th>{{ 'realtime:alarmTime' | i18next }}</th>
      </tr>
    </thead>
    <tbody>
      <tr class="mat-mdc-row" *ngFor="let alarm of items">
        <td>{{ alarm.alarmName }}</td>
        <td class="leftPadding">{{ alarm.basicQueue }}</td>
        <td class="leftPadding">{{ alarm.thresholdTypeName }}</td>
        <td class="leftPadding">{{ alarm.alarmTime }}</td>
      </tr>
    </tbody>
  </table>

  <ng-template #noData>
    <div class="no-items">{{ 'realtime:noResults' | i18next }}</div>
  </ng-template>
</div>
